import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { NavegacionService } from '../../core/navegacion/navegacion.service';
import { PermisosService } from '../../core/services/permisos.service';

/**
 * `/obras` a secas era el hub de módulos de la obra. Ahora esas tarjetas viven en el departamento Siscon: quien llega con el enlace de antes
 * (un marcador, un correo) va a la pantalla de Siscon; si no ve nada de Siscon, al inicio. Es un redireccionamiento (sin entrada nueva en el
 * historial). Todas las demás rutas bajo `/obras/**` siguen donde estaban.
 */
export const obrasASisconGuard: CanActivateFn = async () => {
  const nav = inject(NavegacionService);
  const router = inject(Router);
  await nav.cargarConcedidos();
  return router.createUrlTree([nav.departamentos().some(d => d.id === 'siscon') ? '/menu/siscon' : '/']);
};

/**
 * La puerta de `/obras/elegir-obra/:modulo` (la pantalla completa de selección de obra, que se mantiene por compatibilidad con enlaces
 * guardados): entra quien ve al menos un módulo en algún departamento.
 */
export const elegirObraGuard: CanActivateFn = async () => {
  const nav = inject(NavegacionService);
  const router = inject(Router);
  const permisos = inject(PermisosService);
  await nav.cargarConcedidos();
  if (nav.departamentos().length > 0) return true;
  permisos.denegarAcceso('Obras');
  return router.createUrlTree(['/sin-acceso']);
};
